module.exports = __webpack_public_path__ + "public/af4bddcac899752f83a1db35f541c25a.woff2";